import React from 'react';
import doctor from '../../../images/doctor.png';
import './Appointment.css'
const Appoinment = () => {

    return (
        <div className='appointment'>
            <div className="container">
                <div className="row">
                    <div className="col-md-5 pe-5">
                        <img style={{marginTop:'-130px',width:'130%'}}  src={doctor} alt="" />
                    </div>
                    <div className="col-md-7">
                        <h5 className="head-color mt-5">APPOINTMENT</h5>
                        <h1 className='text-white mt-4'>Make An Appointment <br /> Today</h1>
                        <p className='text-white mt-4 fs-5'>It is a established face that a reader will be destructed by readable content of a page when looking at its</p>
                        <button className='btn-similar mt-4' style={{padding: '12px 45px'}}>Learn More</button>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default Appoinment;